
const SettingsStandardSequenceRSRSCharacteristicDetail = () => import('frontend/pages/settings/standards/SettingsStandardSequenceRSRSCharacteristicDetail')
const SettingsStandardSequenceRSRSCharacteristics = () => import('frontend/pages/settings/standards/SettingsStandardSequenceRSRSCharacteristics')

import { SETTINGS_CARDS_TOKENS } from 'frontend/constants/settings'

export default [
  {
    path: SETTINGS_CARDS_TOKENS.visualStandardRSRSCharacteristics.name,
    name: SETTINGS_CARDS_TOKENS.visualStandardRSRSCharacteristics.name,
    components: {
      default: SettingsStandardSequenceRSRSCharacteristics,
    },
  },
  {
    path: SETTINGS_CARDS_TOKENS.visualStandardRSRSCharacteristics.name + '/:id',
    name: SETTINGS_CARDS_TOKENS.visualStandardRSRSCharacteristics.children.details,
    props: {
      default: (routerInstance) => ({ id: Number(routerInstance.params.id) }),
    },
    components: {
      default: SettingsStandardSequenceRSRSCharacteristicDetail,
    },
  },
]
